import React from 'react';
import { shape, string } from 'prop-types';
import styled from 'styled-components';
import { spacing } from 'TMDesignSystem/spacing';
import { breakpoints } from 'TMConstants';
import AuthorBio from './index';

const Wrapper = styled.div`
    max-width: 1120px;
    margin: 0 auto;
    padding: 0 ${spacing.mediumLarge};

    @media (max-width: ${breakpoints.mobileTablet}px) {
        padding: 0 ${spacing.medium};
    }
`;

const AuthorBioBlock = ({ author }) => {
    if (!author) return null;

    return (
        <Wrapper>
            <AuthorBio author={author} />
        </Wrapper>
    );
};

AuthorBioBlock.propTypes = {
    author: shape({
        name: string,
        jobTitle: string,
        photo: shape({})
    })
};

AuthorBioBlock.defaultProps = {
    author: null
};

export default AuthorBioBlock;
